/**
 * Chat-library UI constants for styling values not represented in shared design tokens.
 *
 * Colors are named with reference to the color constants defined in
 * packages/@benchling-nucleus-ui/src/tokens/Color.ts.
 */

/**
 * Height for the chat input toolbar (plus, agent toggles, send) and contextual chips, aligned with
 * `ButtonSize.MINI` / `@height-mini--button` in `less/variables.less` (24px). Used only under
 * `llm/chat-library/` so other product buttons are unchanged.
 */
export const CHAT_INPUT_TOOLBAR_CONTROL_HEIGHT_PX = 30;

export const AI_BLUE_75 = '#F0F1FE';
export const AI_GRAY_50 = '#F7F7F9';
export const AI_GRAY_175 = '#E8E8EB';
export const AI_GRAY_200 = '#E2E3E5';
export const AI_GRAY_225 = '#D3D3DA';
export const AI_GRAY_290 = '#D3D3D6';
export const AI_GRAY_425 = '#B4B4B9';
export const AI_GRAY_475 = '#A4A4A5';
export const AI_GRAY_CHEVRON = 'rgba(23, 24, 35, 0.32)';
